import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useContext, useEffect, useState } from "react";
import { CategoryContext } from "../../context/categories";
import { TagsContext } from "../../context/tag";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DateObject from "react-date-object";
import { videoFetcher } from "../../api/requests";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useToaster } from "../../context/toaster";
import { formatDuration } from "../../utils/formatDuration";
import { useRef } from "react";

export default function VideoUploadForm({
  handleUploadClick,
  loading,
  setLoading,
  userChannels,
  progress,
  setProgress,
  channelId,
}) {
  const [video, setVideo] = useState({
    channel: channelId,
    video: "",
    title: "",
    cover: "",
    duration: "",
    description: "",
    cast: "",
    categorys: 0,
    sub_categorys: 0,
    tags: [],
    confirm_to_post: true,
    status: true,
    published_date: new DateObject({
      calendar: persian,
      locale: persian_fa,
    }).format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
  });
  const [videoDuration, setVideoDuration] = useState(null);
  const { categories, subCategories } = useContext(CategoryContext);
  const { tags } = useContext(TagsContext);
  const [selectedTags, setSelectedTags] = useState([]);
  const [date, setDate] = useState(
    new DateObject({ calendar: persian, locale: persian_fa })
  );
  const history = useHistory();
  const { addMessage } = useToaster();
  const toastShownRef = useRef(false);

  const handleTagChange = (tagId) => {
    setSelectedTags((prev) => {
      if (prev.includes(tagId)) {
        toastShownRef.current = false;
        return prev.filter((id) => id !== tagId);
      } else if (prev.length < 3) {
        toastShownRef.current = false;
        return [...prev, tagId];
      } else {
        if (!toastShownRef.current) {
          showToast("error", "حداکثر ۳ برچسب قابل انتخاب است.");
          toastShownRef.current = true;
        }
        return prev;
      }
    });
  };

  const handleChange = (name, value) => {
    setVideo({ ...video, [name]: value });
  };

  const showToast = (type, text) => {
    addMessage({
      id: Math.random().toString(36).substr(2, 9),
      type: type,
      text: text,
    });
  };

  const handleVideoUpload = (file) => {
    const url = URL.createObjectURL(file);
    const videoElement = document.createElement("video");
    videoElement.src = url;

    videoElement.addEventListener("loadedmetadata", () => {
      setVideoDuration(videoElement.duration);
      URL.revokeObjectURL(url);
    });

    setVideo((prev) => ({ ...prev, video: file }));
  };

  const handleUpload = async () => {
    if (!video.video) {
      return showToast("error", "لطفا ویدئو را وارد کنید.");
    }

    if (!video.cover) {
      return showToast("error", "لطفا پوستر ویدئو را وارد کنید.");
    }

    if (!selectedTags.length) {
      return showToast("error", "لطفا یک برچسب انتخاب کنید.");
    }

    if (!video.sub_categorys) {
      return showToast("error", "لطفا زیردسته را انتخاب کنید.");
    }

    handleUploadClick();

    const formData = new FormData();
    formData.append("channel", channelId);
    formData.append("video", video.video);
    formData.append("title", video.title);
    formData.append("cover", video.cover);
    formData.append("duration", Math.floor(videoDuration));
    formData.append("description", video.description);
    formData.append("cast", video.cast);
    formData.append("categorys", video.categorys);
    formData.append("sub_categorys", video.sub_categorys);
    formData.append("confirm_to_post", video.confirm_to_post);
    formData.append("status", video.status);
    formData.append("published_date", video.published_date);

    selectedTags.forEach((tag) => {
      formData.append("tags", tag);
    });

    try {
      setLoading(true);
      setProgress(0);
      const res = await videoFetcher.post(formData, setProgress);
      if (res) {
        setLoading(false);
        setProgress(100);
        setTimeout(() => setProgress(0), 1000);
        history.push("/account");
      }
    } catch (error) {
      setLoading(false);
      console.error(error, error?.response?.data?.detail);
      showToast(
        "error",
        error?.response?.data?.detail ?? "خطایی رخ داده است، دوباره تلاش کنید."
      );
      setProgress(0);
    }
  };

  const handleDateChange = (value) => {
    setDate(value.toString().replace(/\//g, "-"));
    setVideo({
      ...video,
      published_date: value.toString().replace(/\//g, "-"),
    });
  };

  useEffect(() => {
    setVideo((prev) => ({ ...prev, tags: selectedTags }));
  }, [selectedTags]);

  return (
    <>
      <div
        style={{
          paddingTop: "30px",
          paddingLeft: "30px",
          paddingRight: "30px",
        }}
      >
        <Row>
          <Col lg={12}>
            <div className="osahan-form">
              <Row>
                <Col lg={12}>
                  <Form.Group controlId="video-title">
                    <Form.Label>عنوان ویدئو</Form.Label>
                    <Form.Control
                      onChange={(e) => handleChange("title", e.target.value)}
                      type="text"
                      placeholder="عنوان..."
                    />
                  </Form.Group>
                </Col>
                <Col lg={12}>
                  <Form.Group controlId="video-description">
                    <Form.Label>درباره</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="توضیحات..."
                      onChange={(e) =>
                        handleChange("description", e.target.value)
                      }
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col lg={3}>
                  <Form.Group controlId="video-upload">
                    <Form.Label>ویدئو</Form.Label>
                    <Form.Control
                      type="file"
                      accept="video/*"
                      onChange={(e) => handleVideoUpload(e.target.files[0])}
                      className="form-control-file"
                    />
                  </Form.Group>
                  {videoDuration && (
                    <p>
                      مدت زمان ویدئو:{" "}
                      {formatDuration(Math.floor(videoDuration))}
                    </p>
                  )}
                </Col>

                <Col lg={3}>
                  <Form.Group controlId="cover-upload">
                    <Form.Label>پوستر ویدئو</Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleChange("cover", e.target.files[0])}
                      className="form-control-file"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col lg={4}>
                  <Form.Group controlId="video-casting">
                    <Form.Label>تهیه کنندگان</Form.Label>
                    <Form.Control
                      onChange={(e) => handleChange("cast", e.target.value)}
                      type="text"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col lg={12} style={{ marginTop: "20px" }}>
                  <div className="main-title">
                    <h6>دسته بندی (یک مورد)</h6>
                  </div>
                </Col>
              </Row>

              <Row
                className="category-checkbox"
                style={{
                  padding: "0px 15px",
                  maxHeight: "500px",
                  overflow: "auto",
                }}
              >
                {categories?.map((item, index) => (
                  <Form.Check
                    type="radio"
                    custom
                    label={item?.name}
                    name="category"
                    id={`category + ${item?.id}`}
                    onChange={(e) => handleChange("categorys", item?.id)}
                    key={index}
                  />
                ))}
              </Row>

              <Row>
                <Col lg={12} style={{ marginTop: "20px" }}>
                  <div className="main-title">
                    <h6>زیردسته (یک مورد)</h6>
                  </div>
                </Col>
              </Row>

              <Row
                className="category-checkbox"
                style={{
                  padding: "0px 15px",
                  maxHeight: "500px",
                  overflow: "auto",
                }}
              >
                {subCategories?.map((item, index) => (
                  <Form.Check
                    type="radio"
                    custom
                    label={item?.name}
                    name="subCategory"
                    id={`subCategory + ${item?.id}`}
                    onChange={(e) => handleChange("sub_categorys", item?.id)}
                    key={index}
                  />
                ))}
              </Row>

              <Row>
                <Col lg={12} style={{ marginTop: "20px" }}>
                  <div className="main-title">
                    <h6>برچسب (حداکثر سه مورد)</h6>
                  </div>
                </Col>
              </Row>

              <Row
                className="category-checkbox"
                style={{
                  padding: "0px 15px",
                  maxHeight: "500px",
                  overflow: "auto",
                }}
              >
                {tags?.results?.map((item, index) => (
                  <Form.Check
                    type="checkbox"
                    custom
                    label={item?.name}
                    id={`tag + ${item?.id}`}
                    name="tag"
                    checked={selectedTags.includes(item?.id)}
                    onChange={() => handleTagChange(item?.id)}
                    key={index}
                  />
                ))}
              </Row>

              <Row>
                <Col lg={4}>
                  <Form.Group controlId="video-casting">
                    <Form.Label
                      style={{
                        marginLeft: "10px",
                        marginTop: "20px",
                        marginRight: "6px",
                      }}
                    >
                      تاریخ انتشار
                    </Form.Label>
                    <DatePicker
                      value={date}
                      onChange={handleDateChange}
                      format="YYYY/MM/DD HH:mm:ss"
                      calendar={persian}
                      locale={persian_fa}
                      calendarPosition="bottom-right"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </div>
            <div className="osahan-area text-center mt-3 mb-4">
              <Button
                variant="outline-primary"
                onClick={handleUpload}
                style={{
                  cursor: loading ? "wait" : "pointer",
                }}
              >
                {loading ? "لطفا منتظر بمانید..." : "ارسال"}
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}
